// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLGlobalStatus } from '../global';
import { selectKLHomeVisitedIndex, selectKLTmpNotifications } from '../misc';

const selectHasTmpNotifications = createSelector(
  [selectKLTmpNotifications],
  (tmpNotifications) => !!tmpNotifications?.length,
);

// isEliminatedView => homeVisitedIndex === null or 3
// But we don't want to display sound when the user come back from adventure review
const selectIsEliminatedView = createSelector(
  [selectKLHomeVisitedIndex],
  (homeVisitedIndex) => homeVisitedIndex === null,
);

const selectShouldPlaySound = createSelector(
  [selectHasTmpNotifications, selectIsEliminatedView],
  (hasTmpNotifications, isEliminatedView) => !hasTmpNotifications && isEliminatedView,
);

const selectKLEliminatedViewProps = createSelector(
  [selectShouldPlaySound, selectKLGlobalStatus],
  (shouldPlaySound, globalStatus) => ({
    shouldPlaySound,
    globalStatus,
  }),
);

export default selectKLEliminatedViewProps;
